import { HotelService } from "@/types/hotelService";

export const DEFAULT_AMENITY_CATEGORIES = [
  "Restaurant",
  "Bar",
  "Pool",
  "Spa",
  "Gym",
  "Kids",
  "Adult Only",
  "Beach",
  "Garden",
  "Lounge",
  "Terrace",
  "Business Center",
  "Entertainment",
  "Pet Friendly Zone",
  "Smoking Area",
  "Quiet Zone",
] as const;

export enum WeekDay {
  Mon = "Mon",
  Tue = "Tue",
  Wed = "Wed",
  Thu = "Thu",
  Fri = "Fri",
  Sat = "Sat",
  Sun = "Sun",
}

export interface Schedule {
  id: string;
  days: WeekDay[];
  startTime: string; // HH:mm
  endTime: string; // HH:mm
  amenityId: string;
}

export interface Amenity {
  id: string;
  name: string;
  description: string;
  category: string;
  isActive: boolean;
  hotelId: string;
  photoId?: string | null;
  /** Starred for the guest home screen (GET /amenities/home). */
  showOnHome?: boolean;
  /** Place among starred amenities, written by the server. */
  homeOrder?: number;
  schedules: Schedule[];
  services: HotelService[];
  createdAt: string;
  updatedAt: string;
}
